import { Node } from "#/decision_tree_viewer/models/node";

export class StartNode extends Node {
  get defaults() {
    return {
      ...super.defaults,
      name: "StartNode",

      isNested: false,
      step: false,

      title: undefined,
      message: undefined,

      targetNodeId: "continue",
    };
  }

  get possibleNextNodeIds() {
    return [this.targetNodeId];
  }

  autoAdvance() {
    return !this.step;
  }

  nextNodeId() {
    return this.targetNodeId;
  }
}
